import { useState, useEffect } from "react";
import { supabase } from "@/libs/supabase";
import type { Channel } from "@/types/channel/channel";

export const useChannels = () => {
	const [channels, setChannels] = useState<Channel[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		const fetchChannels = async () => {
			try {
				const { data, error } = await supabase
					.from("channels")
					.select("*")
					.order("created_at", { ascending: true });

				if (error) throw error;
				setChannels(data);
			} catch (e) {
				setError(
					e instanceof Error ? e : new Error("チャンネルの取得に失敗しました"),
				);
			} finally {
				setLoading(false);
			}
		};

		fetchChannels();

		// リアルタイム購読
		const subscription = supabase
			.channel("channels")
			.on(
				"postgres_changes",
				{
					event: "*",
					schema: "public",
					table: "channels",
				},
				(payload) => {
					// 変更に応じてチャンネル一覧を更新
					fetchChannels();
				},
			)
			.subscribe();

		return () => {
			subscription.unsubscribe();
		};
	}, []);

	return { channels, loading, error };
};
